(function () {
	let prodcarousel = () => {
		$(".product-carousel-recom").each(function () {
			let slideEl = $(this).find(".product-carousel__wrapper");
			let carousel = $(this).find(".swiper-carousel");
			let slide = $(this).find(".swiper-slide");
			let buttonNext = $(this).find(".swiper-button-next");
			let prodCountHalf = parseFloat(slideEl.data("count")) + 0.1;
			if ($(this).hasClass("slider_started")) {
				return "";
			}

			$(this).addClass("slider_started");
			let ele = ".product-carousel-recom";

			let prodSwiperParams = {
				centeredSlides: false,
				slidesPerView: 3,
				waitForTransition: false,
				watchSlidesProgress: true,
				updateOnWindowResize: true,
				preloadImages: true,
				allowTouchMove: true,
				slidesOffsetBefore: 32,
				slidesOffsetAfter: 32,
				spaceBetween: 4,
			};

			let swiperSlider = new Swiper(`${ele} .swiper-carousel`, {
				navigation: {
					nextEl: `${ele} .swiper-button-next__prod`,
					prevEl: `${ele} .swiper-button-prev__prod`,
				},
				...prodSwiperParams,
			});
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		prodcarousel();
	});

	document.addEventListener("shopify:section:load", function () {
		prodcarousel();
	});

	document.addEventListener("resize", function () {
		prodcarousel();
	});

	document.addEventListener("visibilitychange", function () {
		prodcarousel();
	});

	prodcarousel();
})();
